import React,{useState,useEffect}from"react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ItemValueEdit from '../../item/itemValueEdit';
import ItemSettingEdit from '../../item/itemSettingEdit';
import Select from "react-select";
import {all_routes} from "../../../../../feature-module/router/all_routes";
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
/* -- biz9 import start -- */
import {Str,Num,Log} from "biz9-utility";
import {Image_Type,Image_Table} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field} from "biz9-portal-app";
import {Config,Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Dashboard_App_Page_Edit = () => {
    const query = UrlQuery();
    const [val_id,setValId] = useState(query.get('id'));
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [val_title,setValTitle] = useState("");
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState(Page_Logic.get_pages());
    const [val_url,setValUrl] = useState("");
    const [val_service_url,setValServiceUrl] = useState("");
    const [val_param,setValParam] = useState("");
    const [val_description,setValDescription] = useState("");
    const [custom_fields,setCustomFields] = useState([]);
    const [field_values,setFieldValues] = useState([]);
    const [image_primary,setImagePrimary] = useState([]);
    const [val_note,setValNote] = useState("");
    const [item,setItem] = useState(Data_Logic.get(Portal_Table.PAGE,val_id));
   //item-edit-end
    useEffect(() => {
       Toast_Message.loading(Message.LOADING);
       if(val_id){
            get_data();
        }
    },[val_id]);
    async function get_data() {
        let [response,data] = await Portal_Remote_CMS.get(App.get_url(Portal_Url.CMS_GET),Portal_Table.PAGE,val_id);
	    bind_page(data[Portal_Type.ITEM]);
        bind_field(data[Portal_Type.ITEM]);
        bind_field_value(data[Portal_Type.ITEM]);
        Toast_Message.dismiss();
 }
    async function bind_page(data) {
        setValSubPageTitle(data.title);
    };
    async function bind_field(data) {
        setItem(Data_Logic.clean(data));
        setValTitle(data.title);
        setValType(types.find(option => option.value === data.type));
        setValDescription(data.description);
        setValUrl(data.url);
        setValServiceUrl(data.service_url);
        setValParam(data.param);
    };
    async function bind_field_value(data) {
          setFieldValues(Data.bind_field_values(data));
   };
const handle_submit = (event) =>{
    event.preventDefault();
};
async function post_field(item,field,value,option){
        if(!value){
            value = '';
        }

        if(field == Portal_Field.TYPE){
            let portal_page = Page_Logic.get_page_by_type(value);
            item[Portal_Field.TITLE] = portal_page.title;
            item[Portal_Field.TITLE_URL] = portal_page.title_url;
            console.log('aaaaaaa',item);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
            Toast_Message.error(Str.get_title(field) + " " +Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[field] = value;
            setItem(item);
            bind_page(item);
            let option_post = {overwrite:true,clean:true};
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.PAGE,item,option_post);
            console.log('bbbbbb',data);
            if(!option.success_message){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
   const updateValTitle = (event) => {
            setValTitle(event.target.value);
    };
const updateValType = (selectedOption) => {
    setValType(selectedOption);
    setValTitle(selectedOption.label);
    post_field(item,Portal_Field.TYPE,selectedOption.value,{});
};
const updateValDescription = (event) => {
    setValDescription(event.target.value);
};
const updateValUrl = (event) => {
    setValUrl(event.target.value);
};
const updateValParam = (event) => {
    setValParam(event.target.value);
};
return (
        <>
        <Toaster />
        {/* Page Content */}
        <div className="page-wrapper">
        <div className="page-content content bg-light">
        <div className="row justify-content-center">
        <div className="col-lg-10">
        <div className="main-title mb-4">
        <h4>{val_sub_page_title}</h4>
        </div>
        <div className="settings-info bg-white">
<ul className="nav nav-tabs nav-tabs-bottom mb-4">
<li className="nav-item">
<Link to={all_routes.dashboard_app_page} className="nav-link" >
{Dashboard.get_dash_edit_item_back_link(Portal_Table.PAGE)}
</Link>
</li>
</ul>
        <div className="settings-page-lists">
        <ul className="settings-head nav nav-tabs" role="tablist">
        <li className="nav-item" role="presentation">
        <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_general"
        aria-selected="false" role="tab" tabIndex={-1}>
{Title.LABEL_CMS_TAB_GENERAL}

        </Link>
        </li>
        <li className="nav-item" role="presentation">
        <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_value" aria-selected="false"
role="tab" tabIndex={-1}>
{Title.LABEL_CMS_TAB_VALUE}
</Link>
</li>
<li className="nav-item" role="presentation">
<Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_setting" aria-selected="false" role="tab"
tabIndex={-1}>
{Title.LABEL_CMS_TAB_SETTING}
</Link>
</li>
</ul>
</div>
<div className="tab-content">
{/* General Tab  */}
<div className="tab-pane fade show active" id="tab_general" role="tabpanel">
<div className="settings-card">
<div className="settings-card-head bg-light">
<h4>General</h4>
</div>
<form onSubmit={handle_submit}>
<div className="settings-card-body">
<div className="row">
<div className="col-md-12">
<div className="form-wrap mb-3">
<label className="mb-1 fw-medium text-dark">
{" "}
Type{" "}
<span className="text-primary">*</span>
</label>
<Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={types} value={val_type} onChange={updateValType} />
</div>
</div>

<div className="col-md-12">
<div className="form-wrap mb-3">
<label className="mb-1 fw-medium text-dark">
{" "}
Title{" "}
<span className="text-primary">*</span>
</label>
<input value={val_title} onChange={updateValTitle} type="text" disabled={true} className="form-control" onBlur={() => post_field(item,Field.FIELD_TITLE,val_title,{required:true})} />
</div>
</div>

<div className="col-md-12">
<div className="form-wrap mb-3">
<label className="mb-1 fw-medium text-dark">
{" "}
Url{" "}
<span className="text-primary">*</span>
</label>
<input value={val_url}  disabled={false} onChange={updateValUrl} type="text" className="form-control" onBlur={() => post_field(item,Portal_Field.URL,val_url,{required:false})} />
</div>
</div>
<div className="col-md-12">
<div className="form-wrap mb-3">
<label className="mb-1 fw-medium text-dark">
{" "}
Param{" "}
</label>
<input value={val_param} onChange={updateValParam} type="text" className="form-control"  onBlur={() => post_field(item,Field.PARAM,val_param,{required:false})} />
</div>
</div>

<div className="col-md-12">
<div className="form-wrap mb-3">
<label className="mb-1 fw-medium text-dark">
{" "}
Description{" "}
</label>
<input value={val_description} onChange={updateValDescription} onBlur={() => post_field(item,Field.DESCRIPTION,val_description,{})} type="text" className="form-control" />
</div>
</div>

</div>
</div>
</form>
</div>
</div>
{/* /General Tab  */}
{/* Value Tab */}
<div className="tab-pane fade" id="tab_value" role="tabpanel">
<ItemValueEdit field_values={field_values} item={item} onFieldValuesUpdate={setFieldValues} onItemUpdate={setItem} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
</div>
{/* Value Tab */}
{/* Setting Tab */}
<div className="tab-pane fade" id="tab_setting" role="tabpanel">
<ItemSettingEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />

</div>
{/* Setting Tab */}
</div>
{/* /Page Content */}
</div>
</div>
</div>
</div>
</div>
{/* /Page Content */}
</>
);
};
export default Dashboard_App_Page_Edit;
